import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { WaitingManager, WaitingOptions } from "./WaitingManager";
import {
  WaitingPopupWrapper,
  Backdrop,
  SpinnerContainer,
  MessageContainer,
  ProgressBarContainer,
  ProgressFill,
} from "./style";
import Spinner from "components/atoms/Spinner";
import { COLOR_SYSTEM } from "components/design/design-system";

const WaitingPopup: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<WaitingOptions | null>(null);

  useEffect(() => {
    const handleChange = (state: { visible: boolean; options: WaitingOptions | null }) => {
      setVisible(state.visible);
      setOptions(state.options);
    };

    WaitingManager.addListener(handleChange);
    return () => WaitingManager.removeListener(handleChange);
  }, []);

  // 보여줄 것이 없으면 아무것도 렌더링하지 않음
  if (!visible || !options) return null;

  // Portal을 사용하여 body에 직접 렌더링
  return ReactDOM.createPortal(
    <WaitingPopupWrapper>
      <Backdrop />
      <SpinnerContainer>
        <Spinner size="Large" color="#3B82F6" />
        {options.message && <MessageContainer>{options.message}</MessageContainer>}
        {options.showProgress && (
          <ProgressBarContainer>
            <ProgressFill progress={options.progress || 0} />
          </ProgressBarContainer>
        )}
      </SpinnerContainer>
    </WaitingPopupWrapper>,
    document.body
  );
};

export default WaitingPopup;
